
export const BOTTOM_MARGIN = 10; // px
export const COLLAPSED_ACTIVITY_WIDTH = 250; // px
export const COLLAPSED_ANSWER_WIDTH = 60; // px
export const FULL_ANSWER_WIDTH = 350; // px
export const MC_SUMMARY_APPROX_WIDTH = 100; // px
